import React, { useContext } from 'react'
import DefaultTooltip from '../../../../Tooltip'
import './assignmentMenu.scss'
import { SelectColumnsContext } from '../select-columns/SelectColumnsContext'
import { OrderByColumnsContext } from '../orderby-columns/OrderByColumnsContext'
import { GroupByColumnsContext } from '../groupby-columns/GroupByColumnsContext'

const IconWrapper = ({ onClick, tooltipText, name, extraClass, children }) => {
    return (
        <div
            className="assignmentActionButton"
            onClick={onClick}
            data-tooltip-content={`${tooltipText}`}
            data-tooltip-id={`${name}`}
        >
            <button 
                type="button"
                className={`button ${extraClass}`}
            >
                <span>
                    {children}
                    <DefaultTooltip className={'assignmentTooltip'} id={name} stayOpen={false} />
                </span>
            </button>
        </div>
    )
}

const useAssignmentContext = (mode) => {
    const selectContext = useContext(SelectColumnsContext)
    const orderByContext = useContext(OrderByColumnsContext)
    const groupByContext = useContext(GroupByColumnsContext)

    switch (mode) {
        case 'orderBy':
            return orderByContext
        case 'groupBy':
            return groupByContext
        case 'select':
        default:
            return selectContext
    }
}

const AssignSelected = ({ mode = 'select' }) => {
    const { assign } = useAssignmentContext(mode)
    const onClick = () => {
        assign()
    }

    return (
        <IconWrapper
            name="assignSelected"
            tooltipText="Add Highlighted"
            onClick={onClick}
            extraClass={`is-primary`}
        >
            {`>`}
        </IconWrapper>
    )
}

const UnassignSelected = ({ mode = 'select' }) => {
    const { unassign } = useAssignmentContext(mode)
    const onClick = () => {
        unassign()
    }

    return (
        <IconWrapper
            name="unassignSelected"
            tooltipText="Remove Highlighted"
            onClick={onClick}
            extraClass="is-danger"
        >
            {`<`}
        </IconWrapper>
    )
}

const AssignAll = ({ mode = 'select' }) => {
    const { assign } = useAssignmentContext(mode)
    const onClick = () => {
        // assign all possible facilities to the project
        assign(true)
    }

    return (
        <IconWrapper
            name="assignAll"
            tooltipText="Add All"
            onClick={onClick}
            extraClass={'is-primary'}
        >
            {`>>`}
        </IconWrapper>
    )
}
const UnassignAll = ({ mode = 'select' }) => {
    const { unassign } = useAssignmentContext(mode)
    const onClick = () => {
        unassign(true)
    }

    return (
        <IconWrapper
            name="unassignAll"
            tooltipText="Remove All"
            onClick={onClick}
            extraClass="is-danger"
        >
            {`<<`}
        </IconWrapper>
    )
}

const AssignActions = ({ mode = 'select' }) => {
    return (
        <div className="assignmentActionsWrapper">
            <AssignAll mode={mode} />
            <AssignSelected mode={mode} />
            <UnassignSelected mode={mode} />
            <UnassignAll mode={mode} />
        </div>
    )
}
export default AssignActions